export default __webpack_public_path__ + "img/736befcd15bfd5cddc0b0046f2cebcb9.svg";